// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ios-segment-button-last {
  border-radius: 0 4px 4px 0;
}

.ios-segment-button-first {
  border-radius: 4px 0 0 4px;
}

.styled_text {
  color: var(--ion-color-danger) !important;
}

.segment-color {
  background-color: #f6f6ff !important;
}

.weather-station-segment {
  width: 100% !important;
  display: flex !important;
}

.weather-station-button {
  flex: 1 1 100% !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
}

.weather-station-button::part(native) {
  width: 100% !important;
}

ion-segment.secondSegment {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
}

ion-segment-button.vendordetailsSegment {
  flex: 1 1 50% !important;
  width: 50% !important;
  min-width: 50% !important;
  max-width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/weather/weather.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,sBAAA;EACA,wBAAA;AAEF;;AACA;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,0BAAA;AAEF;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,sBAAA;EACA,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;AAEF;;AACA;EACE,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0BAAA;AAEF","sourcesContent":[".ios-segment-button-last {\n  border-radius: 0 4px 4px 0;\n}\n\n.ios-segment-button-first {\n  border-radius: 4px 0 0 4px;\n}\n\n.styled_text {\n  color: var(--ion-color-danger) !important;\n}\n.segment-color{\n  background-color: #f6f6ff !important;\n}\n\n.weather-station-segment {\n  width: 100% !important;\n  display: flex !important;\n}\n\n.weather-station-button {\n  flex: 1 1 100% !important;\n  width: 100% !important;\n  min-width: 100% !important;\n  max-width: 100% !important;\n}\n\n.weather-station-button::part(native) {\n  width: 100% !important;\n}\n\nion-segment.secondSegment {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n}\n\nion-segment-button.vendordetailsSegment {\n  flex: 1 1 50% !important;\n  width: 50% !important;\n  min-width: 50% !important;\n  max-width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
